function testimonialFeature() {
    // Handle video modal clicks
    $('.testimonial-feature .testimonial-video').on('click', function(e) {
        e.preventDefault();
        const $this = $(this);
        const videoId = $this.data('video-id');

        if (!videoId) return;

        // Create YouTube embed with autoplay
        const modalHTML = `
            <div class="video-modal">
                <div class="video-modal__content">
                    <iframe
                        width="100%"
                        height="100%"
                        enablejsapi="1"
                        src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen>
                    </iframe>
                </div>
            </div>
        `;

        // Insert content and open modal
        $('.modal-window__target').html(modalHTML);
        openModal();
    });
}
